import React from "react";
import { Container } from "react-bootstrap";

const AboutCommon = () => {
  return (
    <>
      <Container>
        <h1 className="text-center my-3">About Pro-Active</h1>
        <hr className="w-25 mx-auto" />
        <p>
          The <span style={{ fontWeight: "bold" }}>Pro-Active </span>Institute
          is a leading independent global medical research institute established
          and headquartered in Sydney, with additional major centres in China,
          India and the UK and an international network of experts and
          collaborators. Our mission is to improve the health of millions of
          people worldwide, particularly those living in disadvantaged
          circumstances, by challenging the status quo and using innovative
          approaches to prevent and treat non-communicable diseases and injury.
        </p>
      </Container>
    </>
  );
};

export default AboutCommon;
